// hooks/useEscapeKey.js

import { useEffect } from 'react';

/**
 * Hook pour gérer la touche Escape
 * Utile pour fermer des modales, popups, etc.
 * 
 * @param {Function} onEscape - Callback appelé quand Escape est pressé
 * @param {boolean} enabled - Active/désactive l'écoute (défaut: true)
 * 
 * @example
 * useEscapeKey(() => setModalOpen(false));
 * 
 * @example
 * // Avec condition
 * useEscapeKey(() => closeModal(), isModalOpen);
 */
export const useEscapeKey = (onEscape, enabled = true) => {
  useEffect(() => {
    // Si désactivé, ne rien faire
    if (!enabled) return;

    // Handler de l'événement
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' || event.key === 'Esc') {
        onEscape();
      }
    };

    // Ajouter l'écouteur
    document.addEventListener('keydown', handleKeyDown);

    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onEscape, enabled]);
};